import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-anachronisms',
  imports: [Link, RouterLink],
  templateUrl: './anachronisms.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './anachronisms.scss',
})
export class Anachronisms {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Anachronisms`);
    this.dynamicTitle.description(`Anachronisms are things that are out of place in time. Many anachronisms have been pointed out by scholars suggest that Jesus is not a historical figure.`);
  }
}
